module.exports = __webpack_public_path__ + "static/img/avatar_popmart.acbca92.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/avatar_popmart.png
// module id = Tm36
// module chunks = 1